import { declareGlobals } from './globals';
import { DisplayAdComponent } from './components/display-ad-component';
import { APNTag } from './apntag/';

export const CUSTOM_ELEMENT = 'display-ad-component';

export async function main(scope: any, customElementRegistry: CustomElementRegistry) {
  if (customElementRegistry.get(CUSTOM_ELEMENT)) throw new Error('Attempted to load display-ads.js when <display-ad-component> is already defined.');
  APNTag.getInstance();
  declareGlobals(scope);
  customElementRegistry.define(CUSTOM_ELEMENT, DisplayAdComponent);
}
